/// <reference types="vite/client" />
import { Outlet, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Favicon from "react-favicon";
import './App.css'; // Import global styles

function App() {
  const location = useLocation();
  const hideNav = [
    '/dashboard', '/dashboard/repos', '/dashboard/settings',
  ].includes(location.pathname);

  return (
    
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {!hideNav && <NavBar />}
      {/* This ensures the Outlet stretches to fill the space between NavBar and Footer */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </div>
      <Footer />
      <Favicon url='/logo_only_256x256.png' />

    </div>
  );
}



export default App;
